import * as actionTypes from "./actionTypes";
import {appError, appLoading, appSuccess} from "./appActions";
import {
    listCountriesApi,
    listLanguagesApi,
    listTimezoneByCountryApi,
    registerTenantDataApi,
    validateTenantNameApi,
    listIndustriesByLangApi,
    listProfilesByLangApi,
    listJobRolesByLangApi
} from "../../api/stepsUrl";
import {registerAccountApi} from "../../api/registerAccountUrl";
import {toastr} from "react-redux-toastr";
import {registerAccountSuccess} from "./actionRegister";
import LocalStorageService from "../../services/LocalStorageService";

export const validateTenantNameSuccess = (data) => ({
    type: actionTypes.VALIDATE_TENANT_NAME_SUCCESS,
    payload: data,
})

export const validateTenantNameError = (error) => ({
    type: actionTypes.VALIDATE_TENANT_NAME_ERROR,
    payload: error,
})

export const listCountriesSuccess = (data) => ({
    type: actionTypes.LIST_COUNTRIES_SUCCESS,
    payload: data,
})

export const listCountriesError = (error) => ({
    type: actionTypes.LIST_COUNTRIES_ERROR,
    payload: error,
})

export const listTimezoneSuccess = (data) => ({
    type: actionTypes.LIST_TIMEZONE_SUCCESS,
    payload: data,
})

export const listTimezoneError = (error) => ({
    type: actionTypes.LIST_TIMEZONE_ERROR,
    payload: error,
})

export const listLanguagesSuccess = (data) => ({
    type: actionTypes.LIST_LANGUAGES_SUCCESS,
    payload: data,
})

export const listLanguagesError = (error) => ({
    type: actionTypes.LIST_LANGUAGES_ERROR,
    payload: error,
})

export const listIndustriesSuccess = (data) => ({
    type: actionTypes.LIST_INDUSTRIES_SUCCESS,
    payload: data,
})

export const listIndustriesError = (error) => ({
    type: actionTypes.LIST_INDUSTRIES_ERROR,
    payload: error,
})

export const listProfilesSuccess = (data) => ({
    type: actionTypes.LIST_PROFILES_SUCCESS,
    payload: data,
})

export const listProfilesError = (error) => ({
    type: actionTypes.LIST_PROFILES_ERROR,
    payload: error,
})

export const listJobRolesSuccess = (data) => ({
    type: actionTypes.LIST_ROLES_SUCCESS,
    payload: data,
})

export const listJobRolesError = (error) => ({
    type: actionTypes.LIST_ROLES_ERROR,
    payload: error,
})

export const validateTenantName = (payload) => (dispatch) => {
    const { tenantName, history } = payload;
    dispatch(appLoading());
    validateTenantNameApi(tenantName)
        .then((response) => {
            const { data } = response;
            dispatch(appSuccess());
            dispatch(validateTenantNameSuccess(data));
        })
        .catch((error) => {
            console.log(error);
            dispatch(appError());
            dispatch(validateTenantNameError(error));
            if (error && error.response && error.response.data) {
                console.log('Error: ', 'No se ha podido validar el nombre del tenant, '+ error.response.data.description);
            } else {
                console.log('Error: ', 'No se ha podido validar el nombre del tenant. Error connected to server');
            }
        });
};

export const listCountries = (payload) => (dispatch) => {
    const { lang, history } = payload;
    dispatch(appLoading());
    listCountriesApi(lang)
        .then((response) => {
            const { data } = response;
            dispatch(appSuccess());
            dispatch(listCountriesSuccess(data));
        })
        .catch((error) => {
            console.log(error);
            dispatch(appError());
            history.push('/');
            dispatch(listCountriesError(error));
            if (error && error.response && error.response.data) {
                console.log('Error: ', 'No se ha podido validar el nombre del tenant, '+ error.response.data.description);
            } else {
                console.log('Error: ', 'No se ha podido validar el nombre del tenant. Error connected to server');
            }
        });

};

export const listLanguages = () => (dispatch) => {
    dispatch(appLoading());
    listLanguagesApi()
        .then((response) => {
            const { data } = response;
            dispatch(appSuccess());
            dispatch(listLanguagesSuccess(data));
        })
        .catch((error) => {
            console.log(error);
            dispatch(appError());
            dispatch(listLanguagesError(error));
            if (error && error.response && error.response.data) {
                toastr.error('ERROR', error.response.data.description);
                console.log( 'Error: ', error.response.data.description);
            } else {
                toastr.error('ERROR: ', "error connected to server");
                console.log('Error: ', 'error connected to server');
            }
        });
};

export const listTimezone = (payload) => (dispatch) => {
    const { lang, countryCode } = payload;
    dispatch(appLoading());
    listTimezoneByCountryApi(countryCode, lang)
        .then((response) => {
            const { data } = response;
            dispatch(appSuccess());
            dispatch(listTimezoneSuccess(data.collection));
        })
        .catch((error) => {
            console.log(error);
            dispatch(appError());
            dispatch(listTimezoneError(error));
            if (error && error.response && error.response.data) {
                toastr.error('ERROR', error.response.data.description);
                console.log( 'Error: ', error.response.data.description);
            } else {
                toastr.error('ERROR: ', "error connected to server");
                console.log('Error: ', 'error connected to server');
            }
        });
};

export const registerTenantData = (payload) => (dispatch) => {
    const { register, history, t } = payload;
    dispatch(appLoading());
    const service = LocalStorageService.getService();
    registerTenantDataApi(register)
        .then((response) => {
            const { data } = response;
            dispatch(appSuccess());
            dispatch(registerAccountSuccess(register));
            console.log(data)
            toastr.success('INFO', 'All register success');
            service.clearToken();
            service.clearAccount();
            history.push('/register-success');
        })
        .catch((error) => {
            console.log(error);
            dispatch(appError());
            if (error && error.response && error.response.data) {
                toastr.error('ERROR', error.response.data.description);
                console.log( 'Error: ', error.response.data.description);
            } else {
                toastr.error('ERROR: ', "error connected to server");
                console.log('Error: ', 'error connected to server');
            }
        });
};


export const listIndustries = (payload) => (dispatch) => {
    const { lang, history } = payload;
    dispatch(appLoading());
    listIndustriesByLangApi(lang)
        .then((response) => {
            const { data } = response;
            dispatch(appSuccess());
            dispatch(listIndustriesSuccess(data));
        })
        .catch((error) => {
            console.log(error);
            dispatch(appError());
            history.push('/');
            dispatch(listIndustriesError(error));
            if (error && error.response && error.response.data) {
                console.log('Error: ', error.response.data.description);
            } else {
                console.log('Error: ', 'error connected to server');
            }
        });
};


export const listProfiles = (payload) => (dispatch) => {
    const { lang, history } = payload;
    dispatch(appLoading());
    listProfilesByLangApi(lang)
        .then((response) => {
            const { data } = response;
            dispatch(appSuccess());
            dispatch(listProfilesSuccess(data));
        })
        .catch((error) => {
            console.log(error);
            dispatch(appError());
            history.push('/');
            dispatch(listProfilesError(error));
            if (error && error.response && error.response.data) {
                console.log('Error: ', error.response.data.description);
            } else {
                console.log('Error: ', 'error connected to server');
            }
        });
};


export const listRoles = (payload) => (dispatch) => {
    const { lang, history } = payload;
    dispatch(appLoading());
    listJobRolesByLangApi(lang)
        .then((response) => {
            const { data } = response;
            dispatch(appSuccess());
            dispatch(listJobRolesSuccess(data));
        })
        .catch((error) => {
            console.log(error);
            dispatch(appError());
            history.push('/');
            dispatch(listJobRolesError(error));
            if (error && error.response && error.response.data) {
                console.log('Error: ', error.response.data.description);
            } else {
                console.log('Error: ', 'error connected to server');
            }
        });
};
